import React, { Component } from 'react';
import Supplier from '../Suplier/List'
import ContactUs from '../ContactUs'
import { do_action } from '../../actions'

class index extends Component {

    render() {
        let page_key = window.seo_page || ""
        if (page_key == 'supplier') {
            return <Supplier {...this.props}/>
        }

        if (page_key == 'contact-us') {
            return <ContactUs {...this.props}/>
        }
        
        return (
            <div>
                
            </div>
        );
    }
}

export default index;